import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const ADMIN_AUDIENCE = 'https://admin.schmodel.com';

export function createApolloClient(getAccessTokenSilently, onAdminSessionExpired) {
  const authLink = setContext(async (_, { headers }) => {
    // Registration flow: token stored in localStorage
    const localToken = localStorage.getItem('token');
    if (localToken) return { headers: { ...headers, Authorization: localToken } };

    // Admin flow: get fresh token from Auth0, refresh token handled automatically
    try {
      const token = await getAccessTokenSilently({ authorizationParams: { audience: ADMIN_AUDIENCE } });
      return { headers: { ...headers, Authorization: token } };
    } catch (e) {
      if (e.error === 'login_required' || e.error === 'invalid_grant') {
        if (onAdminSessionExpired) onAdminSessionExpired();
      }
    }
    return { headers };
  });

  return new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.forEach(({ message, locations, path }) =>
              console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
          );
          if (graphQLErrors.some(({ message }) => message === 'invalid signature')) {
            if (onAdminSessionExpired) onAdminSessionExpired();
          }
        }
        if (networkError) console.log(`[Network error]: ${networkError}`);
      }),
      authLink,
      new BatchHttpLink({ uri: process.env.REACT_APP_GRAPHQL_URI })
    ]),
    cache: new InMemoryCache()
  });
}
